import React from 'react';
import styled from 'styled-components';

function ProgressBar({percentage}) {
  return (
    <MaxWidth>
      <Filler width={percentage} />
    </MaxWidth>
  );
}

const MaxWidth = styled.div`
  width: 100%;
  background-color: #F5F5F6;
  height: 12px;
  border-radius: 20px;
  box-shadow: -2px 2px 10px 0 rgba(90,97,105, 0.25) inset
`;

const Filler = styled.div`
  width:${props => props.width}%;
  height: 12px;
  border-radius: 20px;
  background-color:#0049EE;
`;

export default ProgressBar;